import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "flex text-sm" }
const _hoisted_3 = { class: "mr-1" }
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = { class: "mr-1" }
const _hoisted_6 = { class: "font-bold" }
const _hoisted_7 = { class: "mr-1" }
const _hoisted_8 = { class: "font-bold" }
const _hoisted_9 = { class: "font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _cache[0] || (_cache[0] = _createTextVNode("Righe totali: ")),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.pagination.total), 1)
      ]),
      _createElementVNode("span", _hoisted_5, [
        _cache[1] || (_cache[1] = _createTextVNode("Righe per pagina: ")),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.pagination.per_page), 1)
      ]),
      _createElementVNode("span", _hoisted_7, [
        _cache[2] || (_cache[2] = _createTextVNode("Pagine: ")),
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.pagination.current_page), 1),
        _cache[3] || (_cache[3] = _createTextVNode(" di ")),
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.pagination.last_page), 1)
      ])
    ])
  ]))
}